import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/demo")({
  component: lazyRouteComponent(() => import("./+route.lazy")),
  validateSearch: object({
    path: fallback(optional(string(), "/"), "/"),
  }),
});
